import { useEditSavedRowDesignState } from 'modules/templateEditor/hooks/useEditSavedRowDesignState';
import { FC } from 'react';
import { EditSavedRowDesignContext } from './EditSavedRowDesignContext';

export const EditSavedRowDesignProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const editSavedRowDesignState = useEditSavedRowDesignState();

  return (
    <EditSavedRowDesignContext.Provider value={editSavedRowDesignState}>
      {children}
    </EditSavedRowDesignContext.Provider>
  );
};
